import React, { useState, useEffect } from 'react';
import { applications as mockApps } from '../mockData';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Clock, MapPin, DollarSign } from 'lucide-react';
import * as api from '../lib/api';

const statusColors = { submitted: 'bg-[#E0E8D0] text-[#0A3900]', reviewing: 'bg-yellow-100 text-yellow-800', shortlisted: 'bg-green-100 text-green-800', rejected: 'bg-red-100 text-red-800', hired: 'bg-[#E0E8D0] text-[#0A3900]' };

const CandidateApplicationsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await api.getCandidateApplications();
        setApplications(Array.isArray(data) ? data : (data.applications || []));
      } catch {
        setApplications(mockApps || []);
      } finally { setLoading(false); }
    };
    load();
  }, [user]);

  return (
    <div className="min-h-screen bg-[#F9FBF5] pt-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">My Applications</h1>

        {loading ? <div className="text-center py-12 text-gray-500">Loading...</div> : applications.length === 0 ? (
          <Card className="p-12 text-center"><h2 className="text-xl font-semibold text-gray-900 mb-2">No applications yet</h2><p className="text-gray-600 mb-4">Start applying to AI jobs to see them here.</p><Button onClick={() => navigate('/jobs')} className="bg-[#0A3900] hover:bg-[#1A5C0A]">Browse Jobs</Button></Card>
        ) : (
          <div className="space-y-4">
            {applications.map((app) => (
              <Card key={app.application_id || app.id} className="p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex flex-col sm:flex-row items-start gap-4">
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-2">
                      <h3 className="text-lg font-semibold text-gray-900">{app.job_title || 'Job Application'}</h3>
                      <Badge className={statusColors[app.status] || 'bg-gray-100 text-gray-800'}>{app.status}</Badge>
                    </div>
                    <p className="text-gray-600 mb-3">{app.company_name || ''}</p>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                      <span className="flex items-center gap-1"><Clock className="w-4 h-4" />Applied {app.applied_at || app.created_at || ''}</span>
                    </div>
                  </div>
                  <Button variant="outline" onClick={() => navigate(`/jobs/${app.job_id}`)}>View Job</Button>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CandidateApplicationsPage;
